import React from 'react';
import { Modal, Button } from 'antd';
import { ModalBody, Container } from './styles';

const LockStatusCheckModal = props => {
  const { lockedBy, onCancel, visible } = props;

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={'Template locked'}
        centered
        width="625px"
        visible={visible}
        onCancel={() => onCancel()}
        footer={[
          <Button key="back" onClick={() => onCancel()}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => onCancel()}>
            OK
          </Button>,
        ]}
      >
        <ModalBody>
          <div className="warning-text">
            <span>This template was locked </span>
            {lockedBy && (
              <>
                <span>by</span> <span className="text-highlighter"> {lockedBy.displayName}</span>
                <span> Request {lockedBy.displayName} for edit access. </span>
              </>
            )}
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default LockStatusCheckModal;
